import TechBuilderWarningInfo from './TechBuilderWarningInfo';

export default TechBuilderWarningInfo;
